import React, { FC } from 'react';
import Editor, { EditorProps } from './Editor';

const customOptions = {
    toolbarButtons: {
        style: {
            buttons: ['paragraphFormat'],
        },
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'inlineStyle',
                'textColor',
                'clearFormatting',
                'outdent',
                'indent',
            ],
        },
        moreLists: {
            buttons: ['formatOL', 'formatUL'],
        },
        moreRich: {
            buttons: [
                'insertImage',
                'insertLink',
                'insertVideo',
                'insertHR',
                'promotionalContentDropdown',
                'tableauCharts',
                'getPDF',
            ],
            buttonsVisible: 7,
        },
        moreMisc: {
            buttons: ['undo', 'redo'],
            align: 'right',
        },
    },
    toolbarButtonsXS: {
        moreText: {
            buttons: [
                'paragraphFormat',
                'formatOL',
                'formatUL',
                'bold',
                'italic',
                'underline',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'inlineStyle',
                'textColor',
                'clearFormatting',
                'outdent',
                'indent',
            ],
        },
        moreRich: {
            buttons: [
                'insertImage',
                'insertLink',
                'insertVideo',
                'insertHR',
                'promotionalContentDropdown',
                'getPDF',
            ],
            buttonsVisible: 2,
        },
        moreMisc: {
            buttons: ['undo', 'redo'],
            align: 'right',
        },
    },
};

const ArticleEditor: FC<EditorProps> = ({
    initialHtml,
    onChange,
    errorMessage,
}) => {
    return (
        <Editor
            initialHtml={initialHtml}
            onChange={onChange}
            errorMessage={errorMessage}
            customOptions={customOptions}
        />
    );
};

export default ArticleEditor;
